import { Directive, Input, ElementRef, OnChanges, OnInit } from '@angular/core';
import * as _ from 'lodash';

/**
 * Generated class for the WebComponentDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
  selector: '[overlay]', // Attribute selector
  exportAs: 'overlay',
})
export class OverlayDirective {
  constructor(public element: ElementRef) {}
  ngOnInit() {
    // switch element to sit below the body
    document.querySelector('ion-app').appendChild(this.element.nativeElement);
  }
}



// WEBPACK FOOTER //
// ./src/directives/overlay/overlay.ts